export enum AdminAppealsPageTabs {
    Appeals = 'appeals',
    Subjects = 'subjects',
}
